var _defs, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoEscudoReposado(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 124.095,
    height: 124.681,
    viewBox: "0 0 124.095 124.681",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.5,
    y1: 0.184,
    x2: 0.5,
    y2: 1,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.177,
    stopOpacity: 0.102
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1
  })))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_12735",
    "data-name": "Grupo 12735",
    transform: "translate(1288.048 -2453)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_9065",
    "data-name": "Grupo 9065",
    transform: "translate(-1281.001 2460.562)",
    opacity: 0.05,
    style: {
      mixBlendMode: "multiply",
      isolation: "isolate"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8985",
    "data-name": "Grupo 8985"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Uni\\xF3n_3",
    "data-name": "Uni\\xF3n 3",
    d: "M-2048.972-1382.538c-21.721-2.906-36.027-10.093-36.028-18.1v-8.392c0-1.165,2.333-2.177,5.635-2.442l9.941-.8v-2.665c0-1.252,2.69-2.313,6.3-2.485L-2030-1419v0l33.127,1.574c3.612.172,6.3,1.232,6.3,2.485v2.665l9.941.8c3.3.267,5.631,1.278,5.63,2.442v8.393c0,8.008-14.306,15.2-36.028,18.1l-18.967,2.537v0Z",
    transform: "translate(2085 1490)",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "Grupo_8985-2",
    "data-name": "Grupo 8985",
    transform: "translate(-1286.548 2447.562)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5907",
    "data-name": "Trazado 5907",
    d: "M91.3,86.635v13.12l-15.826,3.6a1.889,1.889,0,0,0-1.5,1.834v26.357c0,22.681,14.347,43.038,36.133,51.267l18.864,7.126v-110l-36,4.831A1.913,1.913,0,0,0,91.3,86.635Z",
    transform: "translate(-68.421 -74.501)",
    fill: "#eaeaea"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trazado_5908",
    "data-name": "Trazado 5908",
    d: "M127.916,186.723v3.216l18.866-7.126c21.786-8.229,36.133-28.586,36.133-51.268V105.188a1.889,1.889,0,0,0-1.5-1.834l-15.825-3.6V86.636a1.911,1.911,0,0,0-1.675-1.866l-36-4.831V186.723Z",
    transform: "translate(-67.368 -74.501)",
    fill: "#eaeaea"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoEscudoReposado);
export default __webpack_public_path__ + "static/media/ico-escudo-reposado.ed000e699e5dc170d7f26d34cc7c60c1.svg";
export { ForwardRef as ReactComponent };